// @core/api/endpoints/booking/create_booking_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingNumberingSchemeResponse,
  CreateBookingNumberingSchemeRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Create numbering scheme
 * Creates a booking numbering scheme (e.g., BK-2024-0001). Defines prefix, pattern, and scope for auto-numbering.
 */
export async function CreateBookingNumberingScheme(
  data: CreateBookingNumberingSchemeRequest,
  options?: RequestOptions
): Promise<BookingNumberingSchemeResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/booking-numbering-schemes`;
  const requestOptions = options;
  return client.post<BookingNumberingSchemeResponse>(requestPath, data, requestOptions);
}
